import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getSidebar } from '../utils/storage';

interface UIState {
  dark?: boolean,
  toast: UIToast,
  sidebar: SidebarState,
}

const initialState: UIState = {
  dark: false,
  toast: { intent: 'none', message: '' },
  sidebar: getSidebar() || 'expand',
};

export const uiSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setDarkMode: (state, { payload }: PayloadAction<boolean>) => {
      state.dark = payload;
    },
    setMessage: (state, { payload }: PayloadAction<UIToast>) => {
      state.toast = payload;
    },
    setSidebar: (state, { payload }: PayloadAction<SidebarState>) => {
      state.sidebar = payload;
    },
  },
});

export const { 
  setDarkMode,
  setMessage,
  setSidebar,
} = uiSlice.actions;

export default uiSlice.reducer;
